import React from 'react'

import { Portlet, Row, Col, Button, Form, AsyncSelect } from '_zari/core'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import * as InventariosService from 'services/inventario.service'
import * as ProductoCrud from 'services/producto.service'

import { ClearInputGroup } from 'sharedComponents/utils'

import { MesContabilidadSelect, SelectTipoExistencia, SelectSede } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const Formato13_1 = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)
  const [idProducto, setIdProducto] = React.useState('')
  const [nombreProducto, setNombreProducto] = React.useState('')
  const [idSede, setIdSede] = React.useState('')
  const [mesDesde, setMesDesde] = React.useState(__adminContext.mesTrabajo)
  const [mesHasta, setMesHasta] = React.useState(__adminContext.mesTrabajo)
  const [tipoExistencia, setTipoExistencia] = React.useState('')
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const loadProductosSelect = (inputValue, resolve) => {
    ProductoCrud.obtenerAsSelect2({ busqueda: inputValue }).then(({ data }) => resolve(data))
  }

  const onChangeProductoHandler = infoProducto => {
    setIdProducto(infoProducto.value)
    setNombreProducto(infoProducto.label)
  }

  const getParams = () => ({ idProducto, mesDesde, mesHasta, idSede, tipoExistencia })

  const validar = () => {
    if (!mesDesde) { __zariContext.snack('warning', 'Seleccionar mes.'); return false }
    if (parseFloat(mesDesde) > parseFloat(mesHasta)) { __zariContext.snack('warning', 'El intervalo inicial de mes no puede ser mayor al final.'); return false }
    if (mesDesde !== mesHasta && !idProducto) { __zariContext.snack('warning', 'Para trabajar con intervalo de meses es requerido seleccionar producto.'); return false }
    return true
  }

  const clickDescargar = React.useCallback(() => {
    if (!validar()) return
    __zariContext.loader.open('Descargando reporte - Formato 13.1')
    InventariosService.descargarReporteFormato13_1(getParams())
      .then(({ data, headers }) => { DownloadAxiosFile.downloadAsBlob(data, headers) })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => { __zariContext.loader.close() })
  }, [idProducto, mesDesde, mesHasta, idSede, tipoExistencia, __zariContext])

  const clickBuscar = React.useCallback(() => {
    if (!validar()) return
    setBuscando(true)
    InventariosService.consultaFormato13p1(getParams())
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [idProducto, mesDesde, mesHasta, idSede, tipoExistencia, __zariContext])

  const clickClear = () => { setIdProducto(null); setNombreProducto(null) }

  return (
    <Portlet>
      <Portlet.Header title='Reporte Formato 13.1 - Valorizado' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='PRODUCTO' htmlFor='producto' sm={2} alignRightAt='md' />
              <Col md={10}>
                {idProducto ? (
                  <ClearInputGroup id='input-producto-data-131' iValue={`${nombreProducto}`} clickClear={clickClear} />
                ) : (
                  <AsyncSelect selectId='productoSelect-131' loadOptions={loadProductosSelect} onChange={onChangeProductoHandler} />
                )}
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='MES DESDE' htmlFor='select-mes-desde' md={4} alignRightAt='md' />
              <Col md={8}>
                <MesContabilidadSelect name='select-mes-desde' id='select-mes-desde' value={mesDesde} onChange={e => setMesDesde(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='MES HASTA' htmlFor='select-mes-hasta' md={4} alignRightAt='md' />
              <Col md={8}>
                <MesContabilidadSelect name='select-mes-hasta' id='select-mes-hasta' value={mesHasta} onChange={e => setMesHasta(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='T. EXISTENCIA' htmlFor='select-tiposExistencia' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectTipoExistencia name='select-tiposExistencia' id='select-tiposExistencia' value={tipoExistencia} onChange={e => setTipoExistencia(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='ESTABLECIMIENTO' htmlFor='select-sede' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectSede name='select-sede-131' id='select-sede-131' value={idSede} onChange={e => setIdSede(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargar}>Descargar</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>PRODUCTO</th>
                      <th>FECHA</th>
                      <th>T. DOC.</th>
                      <th>SERIE</th>
                      <th>NUMERO</th>
                      <th>T. OPER.</th>
                      <th className='text-right'>ENTRADAS</th>
                      <th className='text-right'>SALIDAS</th>
                      <th className='text-right'>C. UNIT.</th>
                      <th className='text-right'>C. TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.producto}</td>
                        <td>{r.fecha}</td>
                        <td>{r.tipoDocumento}</td>
                        <td>{r.serie}</td>
                        <td>{r.numero}</td>
                        <td>{r.tipoOperacion}</td>
                        <td className='text-right'>{r.entradas || ''}</td>
                        <td className='text-right'>{r.salidas || ''}</td>
                        <td className='text-right'>{r.costoUnitario}</td>
                        <td className='text-right'>{r.costoTotal}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(Formato13_1)
